export enum DialogMode {
  EDIT = "edit",
  INFO = "view",
  CLOSED = "closed",
  IMPORT = "import",
  DELETE = "delete",
  CONFIRM = "confirm",
  SET_PRICE = "set_price",
  CLEAR_CART = "clear_cart",
  ORDER_FORM = "order_form",
  PLACE_ORDER = "place_order",
  PRODUCT_INFO = "product_info",
  PAID_ORDER = "paid_order",
  COMPLETE_ORDER = "complete_order",
  SHIPPING_ORDER = "shipping_order",
  DELETE_ORDER = "delete_order",
  CANCEL_ORDER = "cancel_order",
  CANCEL_REQUEST = "cancel_request",
  ACCEPT_REQUEST = "accept_request",
  CUSTOM_REQUEST_FORM = "custom_request_form",
  ADD_SHIPPING_LOCATION = "add_shipping_location",
  DELETE_SHIPPING_LOCATION = "delete_shipping_location",
  DELETE_CARRIER = "delete_carrier",
  ADD_CARRIER = "add_carrier",
}
